module.exports = __webpack_public_path__ + "img/present_gray.22b60c2a.svg";